
<script>

  import func from "../../libs/functions.js";

  import {
    mapGetters,
    mapActions
  } from "vuex";
  
  import _ from "lodash";

  import _system from '../../libs/system';

export default {
   name: "CreateWorkspace",
   data() {
      return {
         loading: {
            create: false
         },
         workspace: ''
      }
   },
   computed: {
   ...mapGetters('workspaces', ['workspaces', 'currentWorkspace']),
   ...mapGetters('session', ['isLoggedIn', 'getUser']),
   ...mapGetters('tags', ['tags', 'tagsByName', 'tagsById']),
   ...mapGetters('workspaces', ['workspaces', 'currentWorkspace']),
   },
   methods: {
   ...mapActions("htmlModals", ["setCreateWorkspace"]),
   ...mapActions('tags', ['setTags']),
   ...mapActions('workspaces', ['setWorkspaces', 'pushWorkspace', 'setCurrentWorkspace']),
   ...mapActions('workspaceusers', ['setWorkspaceusers']),
   ...mapActions("loading", ["setLoadingApp", "setLoadingAppReRender"]),   
      create(){

         this.loading.create = true;

         if(!this.workspace){
            return alert('Cannot be empty');
         }

         this.loading = true

         let payload = { "name": this.workspace }
         _system.services.workspaces.create(payload, (err, workspace) => {
         if (err) return console.log(err);

            workspace.plan = 'Free'
         
            this.pushWorkspace(workspace);

            this.setCurrentWorkspace(workspace);

            let payload = {
               workspace: workspace._id,
               user:  this.getUser._id,
               tags :  [this.tagsByName['Admin']._id],
            }
            _system.services.workspaceusers.add(payload, (err, workspaceusers) => {
               if (err) return console.log(err);

                  this.setWorkspaceusers(workspaceusers);

                  this.setLoadingApp(true);

                  this.setLoadingAppReRender(true);

                  this.setCreateWorkspace(false);

                  this.loading.create = false;

            });
         })

      }
   },
   mounted(){
      document.body.addEventListener('keyup', e => { if (e.keyCode === 27) { this.setCreateWorkspace(false) } })
      document.getElementById("searchBox").focus();
   }
}

</script>

<template>


<div class="modalWrapper">
<div  @click="setCreateWorkspace(false)" class="modal"> </div>
   <div class="ui grid">
      <div style="margin-top: 15%;" class="ten wide column centered">
            <div style="padding: 0; z-index:9999999;" class="ui basic segment right aligned">
               <a style="background: rgba(0,0,0,0.6);" @click="setCreateWorkspace(false)" class="ui black mini button">Close [ESC]</a>
            </div>
            <div style="z-index:9999999;" class="ui segment shadow">
               <div class="ui action big input fluid">
                  <input id="searchBox" v-model="workspace" v-on:keyup.enter="create()" style="border:none;" type="text" placeholder="John's Team / Uber / Doordash">
                  <button style="border-radius: 5px;" @click="create();" :class="{ loading: (loading.create) ? true : false }" class="ui blue button">CREATE WORKSPACE</button>
               </div>
            </div>
      </div>
   </div>
</div>


</template>


<style scoped>
.modalWrapper {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   z-index: 9999; 
   overflow: hidden;
}
.modal {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   background: rgba(15, 17, 26, 0.35) none repeat scroll 0% 0%; 
   z-index: 9999; 
   overflow: hidden;
}

.shadow{
   box-shadow: 0px 0px 44px rgba(99, 99, 99, 0.85);
   border: none;
}
</style>





// WEBPACK FOOTER //
// src/components/dashboard/CreateWorkspace.vue